<template>
  
  <div class="container">
  
    <Cabecera></Cabecera>
    <b-breadcrumb>
    <b-breadcrumb-item href="#"><router-link to="/">Inicio</router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/menuinicial">Inicio Usuario </router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/Trazabilidad">Trazabilidad Bovinos</router-link></b-breadcrumb-item>
    
  </b-breadcrumb>
  <div>
  <Menu/>
    
  <b-card>
    
   <br>

        
          <span class="card-title">Registro de ganado bovino</span>
          <form id="formRegistro" autocomplete="off" @submit.prevent="registro" enctype="multipart/form-data">
            <input type="text" placeholder="Unidad" :value=unidad required disabled>
            <input type="date" name="fecharegistro" id="fecharegistro" placeholder="Fecha" v-on:click=usuario() required>
            <input type="hidden" name="factura" id="factura" placeholder="Factura" pattern=".{5,20}" >
            <input type="hidden" name="guia" placeholder="Guía" pattern=".{4,10}" >
            <input type="number"  name="orden" placeholder="Orden de Sacrificio" pattern=".{5,10}" required>
            <input type="text" name="iniciales" placeholder="Iniciales" pattern=".{3,10}" required>
            <input type="text" name="sexo" placeholder="Sexo" pattern="[m,h,M,H]{1,3}" required>
            <input type="text" name="serie" placeholder="Serie" pattern=".{0,5}" v-model="serie" @blur="validarCanal">
            <input type="number" v-model="value" name="canal" id="canal" placeholder="Número de canal" pattern=".{3,10}" @blur="validarCanal" required>
            <input type="number" id="arete" name="arete" placeholder="Arete SNG"  pattern=".{3,20}" v-model="arete" @blur="validarArete" required>
              
             <input type="hidden" name="usuarioForma" id="usuarioForma" :value=usuariolocal>
             <input type="hidden" name="idForma" id="idForma" :value=idActual>
             <input type="hidden" name="unidadForma" id="unidadForma" :value=unidad>
             <input type="hidden" name="fotoForma" id="fotoForma" :value=fotoActual>

           
<div class="card-action">

                        <h6 style="color:Tomato;font-weight:bold;">{{corregir}}</h6>
                        <h6 style="color:Tomato;font-weight:bold;">{{corregir2}}</h6>
                        <input type="submit" value="Registrar" :class="boton">
                        <button class="btn btn-outline-success" v-on:click="limpiar">Limpiar</button>
                           
        </div>
        
            </form>
       
        
          
      
      



    <b-card-body class="text-center">
     

      <b-card-text>
       <div>
    <h5>Listado del día <input width="4" type="date" name="fechadia" id="fechadia" placeholder="Fecha" v-on:click=ajaxdelay() >
     <b-button variant="primary" v-on:click=ajax()>ACTUALIZAR</b-button>
<p id="datetime"></p>
    </h5>
   <vue-good-table
   :columns="columns"
     :rows="rows"
     :line-numbers="true"
     @on-cell-click="onCellClick"
     
     :pagination-options="{
       enabled:true,
      
       mode:'remote',
       perPage:350,
       position:'top',
       perPageDropdown:[10,50,100],
       nextLabel:'Siguiente',
       PrevLabel:'Anterior',
       rowsPerPageLabel:'Filas por página',
       ofLabel:'de'
     }"
     :search-options="{
       enabled:true,
       trigger:'enter',
       placeholder:'Buscar'
     }"
   >
     <template slot="table-row" slot-scope="props">

        <span v-if="props.column.field == 'canal'">
      <input type="text" placeholder="Canal" :id="'canaltabla'+props.formattedRow['id']" name="canaltabla"  :value="props.formattedRow[props.column.field]" :disabled=campostabla> 
    </span>

    <span v-else-if="props.column.field == 'sng'">
      <input type="text" placeholder="Arete" :id="'aretetabla'+props.formattedRow['id']" name="aretetabla"  :value="props.formattedRow[props.column.field]" :disabled=campostabla> 
    </span>

    <span v-else-if="props.column.field == 'iniciales'">
      <input type="text" placeholder="Iniciales" :id="'inicialestabla'+props.formattedRow['id']" name="inicialestabla"  :value="props.formattedRow[props.column.field]" :disabled=campostabla> 
    </span>

    <span v-else-if="props.column.field == 'fecha'">
      <input type="text" placeholder="Fecha" :id="'fechatabla'+props.formattedRow['id']" name="fechatabla"  :value="props.formattedRow[props.column.field]" :disabled=true> 
    </span>
    
    <span v-else-if="props.column.field == 'factura'">
      <input type="text" placeholder="Factura" :id="'facturatabla'+props.formattedRow['id']" name="facturatabla"  :value="props.formattedRow[props.column.field]" :disabled=true> 
    </span>

    <span v-else-if="props.column.field == 'guia'">
      <input type="text" placeholder="Factura" :id="'guiatabla'+props.formattedRow['id']" name="guiatabla"  :value="props.formattedRow[props.column.field]" :disabled=true> 
    </span>

    <span v-else-if="props.column.field == 'permiso'">
      <input type="text" placeholder="Permiso" :id="'permisotabla'+props.formattedRow['id']" name="permisotabla"  :value="props.formattedRow[props.column.field]" :disabled=campostabla> 
    </span>

    <span v-else-if="props.column.field == 'sexo'">
      <input type="text" placeholder="Sexo" :id="'sexotabla'+props.formattedRow['id']" name="sexotabla"  :value="props.formattedRow[props.column.field]" :disabled=campostabla> 
    </span>

    <span v-else-if="props.column.field == 'eliminar'">
       <b-button variant="outline-danger">Eliminar</b-button>
    </span>
    <span v-else-if="props.column.field == 'editar'">
       <b-button variant='danger'>Editar</b-button>
       
    </span>
    <span v-else-if="props.column.field == 'editararete'">
       <input type="number" id="areteeditado" name="areteeditado" placeholder="Arete SNG" :value="props.formattedRow['sng']" :disabled="false">  
    </span>
    <span v-else>
       {{props.formattedRow[props.column.field]}}  
    </span>
    
  </template>
   </vue-good-table>
</div>
      </b-card-text>

     
    </b-card-body>
  </b-card>
</div>

    
  </div>
</template>

<script>
//{{props.formattedRow[props.column.field]}}
import Cabecera from './Cabecera' //v-on:keyup.enter="onEnter"
import Menu from './Menu'
import axios from 'axios'
import swal from 'sweetalert'
import sesion from '../mixins/sesion'
import eliminar from '../mixins/eliminar'
import {mapState, mapMutations, mapActions, mapGetters} from 'vuex'
export default {
  name: 'Trazabilidad',
  data () {
    return {
        value:'1',
        boton:'btn blue disabled',
        campostabla:false,
      msg: 'Número de arete',
      usuariolocal:'',
      fotolocal:'',
      unidad:'',
        fecha1:'',
        fecha2:'',
        areteEditar:'',
        serie:'',
        corregir:'',
        corregir2:'',
        arete:'',
        tamano:'',
      columns:[
        {
          label:'Id',
          field:'id',
          hidden:true
        },
        {
          label:'Folio',
          field:'canal'
        },
        {
          label:'Arete',
          field:'sng'
        },
        {
          label:'Ini.',
          field:'iniciales'
        },
        {
          label:'Fecha',
          field:'fecha',
          type:'date',
          dateInputFormat:'yyyy-mm-dd',
          dateOutputFormat:'yyyy-mm-dd'
        },
        {
          label:'Factura',
          field:'factura'
        },
        {
          label:'Guía',
          field:'guia'
        },
        {
          label:'Permiso',
          field:'permiso'
        },
        {
          label:'Sexo',
          field:'sexo'
        },
        {
          label:'Editar',
          field:'editar'
        },
        {
          label:'Eliminar',
          field:'eliminar'
        },
      ],
      rows:[

      ]
    }
  },
  computed:{
      ...mapState(['usuarioActual','idActual','fotoActual'])
  },
  methods:{
     validarCanal(){
            
                const formData = new FormData()
                formData.append('serie',this.serie)
                formData.append('unidadForma',this.unidad)
                formData.append('canal',this.value)
               /* EN caso de querer mandar más de un dato se repite varias veces y se cambia el nombre y la variable
                FormData.append('correo',this.correo)
                FormData.append('correo',this.correo)*/
                //axios.post('httpss://proyectocdnywebpack.000webhostapp.com/snippetWebpack/api/loginRegistro/validarEmail.php',formData)
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/validarCanalBovinos.php',formData)
                    .then(res=>{
                        this.respuesta = res.data
                        if (res.data =='success') {
                            this.corregir=''
                            if(this.corregir2==''){
                            this.boton = 'btn blue'
                            }
                        } else {
                            this.boton = 'btn blue disabled'
                            this.corregir='El canal indicado ya está registrado'
                            swal({
                    title:'El canal indicado ya está registrado',
                    icon: 'error'}) 
                        }
                    })
    },
    validarArete(){
            
                const formData = new FormData()
                formData.append('serie',this.serie)
                formData.append('unidadForma',this.unidad)
                formData.append('canal',this.value)
                formData.append('arete',this.arete)
               /* EN caso de querer mandar más de un dato se repite varias veces y se cambia el nombre y la variable
                FormData.append('correo',this.correo)
                FormData.append('correo',this.correo)*/
                //axios.post('httpss://proyectocdnywebpack.000webhostapp.com/snippetWebpack/api/loginRegistro/validarEmail.php',formData)
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/validarAreteBovinos.php',formData)
                    .then(res=>{
                        this.respuesta = res.data
                        if (res.data =='success') {
                            this.corregir2=''
                            if(this.corregir==''){
                            this.boton = 'btn blue'
                            }
                            
                        } else {
                            this.boton = 'btn blue disabled'
                            this.corregir2='El arete indicado ya está registrado'
                            swal({
                    title:'El arete indicado ya está registrado',
                    icon: 'error'}) 
                        }
                    })
    },
    limpiar(){
   document.getElementById('formRegistro').reset()
   this.usuario()
    this.value='1'
    },
    nextPlease(){
      document.getElementById('factura').focus()
    },
     onCellClick(params) {
         if(params.column.field=="eliminar"){
       if(this.eliminar(params.row.id)){
            //swal('hola')
           setTimeout(() => {  this.ajax(); }, 500)
       } 
       else{
         setTimeout(() => {  this.ajax(); }, 3000)
       }        
        // setTimeout(() => {  this.ajax(); }, 5000);
        //this.ajax()
         
         }
         if(params.column.field=="editar"){
           const idquery=params.row.id
           
           //const aretequery=params.row.arete
           //swal('params.row.arete'+idquery)
           //const aretequery=props.formattedRow['sng']
           const aretequery=document.getElementById('aretetabla'+idquery).value
           const canalquery=document.getElementById('canaltabla'+idquery).value
           const inicialesquery=document.getElementById('inicialestabla'+idquery).value
           const facturaquery=document.getElementById('facturatabla'+idquery).value
           const guiaquery=document.getElementById('guiatabla'+idquery).value
           const permisoquery=document.getElementById('permisotabla'+idquery).value
           const sexoquery=document.getElementById('sexotabla'+idquery).value
          axios.get('https://micomidasegura.mx/comidaSegura/api/crud/editarAreteBovinos.php?id='+idquery+'&sng='+aretequery
          +'&canal='+canalquery+'&iniciales='+inicialesquery+'&factura='+facturaquery+'&guia='+guiaquery+'&permiso='+permisoquery+'&sexo='+sexoquery)
                    .then(res=>{
                        this.respuesta = res.data
                        if (res.data =='success') {
                            swal('Registro editado')
                            setTimeout(() => {  this.ajax(); }, 500)
                        } else {
                          swal('Error al editar registro' + res.data)
                        }
                    })}
         
         
       // setTimeout(() => {  this.ajax(); }, 500)
         //
   // alert (params.row.id) // params.row - row object   /// 
    // params.pageIndex - index of this row on the current page.
    // params.selected - if selection is enabled this argument 
    // indicates selected or not
    // params.event - click event
  },
      /*onEnter: function() {
      swal("Mensaje de enter")
    },*/
    fecha(){
        var dt = new Date();
    document.getElementById("datetime").innerHTML = ((dt.getFullYear() +"-"+ (("0"+(dt.getMonth()+1)).slice(-2)) 
    +"-"+ ("0"+dt.getDate()).slice(-2)));
    },
    ajax(){
      //this.getId()
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     const fecha = document.getElementById("fechadia").value
     const unidadquery=this.unidad
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getBovinosProceso.php?fecha='+fecha+'&unidad='+unidadquery)
      .then(response=>{
        this.rows=response.data
       
      })

    },
    ajaxdelay(){
      setTimeout(() => {  this.ajax(); }, 2500)
    },
    getId(){
           this.usuario()

            const id = document.getElementById("usuarioForma").value
            
            axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getPerfilUsuario.php?id='+ id)
            
                .then(response=>{
                   
                    this.unidad = response.data.unidad
                  
                    
                })
                   
        }, 
    usuario(){
        this.fecha()
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     var yourString = this.$localStorage.get('token');
     var result = yourString.slice(1,-1);
     this.usuariolocal= result
     const tok=this.usuariolocal
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getUserData2.php?token='+tok)
      .then(response=>{
       
        this.usuariolocal=response.data.email
        this.unidad=response.data.unidad
        this.perfil=response.data.perfil
      })

    },
    ticketIncremento(){
       // document.getElementById('canal').value=document.getElementById('canal').value++
    this.value=Number(this.value)+1
    this.validarCanal()
    //this.validarArete()
     setTimeout(() => {  this.arete="" }, 500)
    //document.getElementById("arete").value=""
    document.getElementById("arete").focus()
    },
    registro(){
            if(this.boton == 'btn blue disabled'){

            }
            else{
                //document.getElementById('usuarioForma').value=this.$store.state.usuario.token
                /*document.getElementById("usuarioForma").value =this.$store.state.usuarioActual
                document.getElementById("fotoForma").value =this.$store.state.fotoActual
                document.getElementById("idForma").value =this.$store.state.idActual*/
               //this.usuario()
               const form=document.getElementById('formRegistro')
                axios.post('https://micomidasegura.mx/comidaSegura/api/loginRegistro/bovinos1.php',new FormData(form))
                .then(res=>{
                    this.respuesta = res.data
                    this.ajax()
                    this.ticketIncremento()
                        
                   /*swal({
                   title:'Registro almacenado'+res.data,
                    //title:'Registro almacenado'+this.$localStorage.get('usuario')+this.$localStorage.getElementById('token'),
                    icon: 'success'})*/
                     
                    //this.direccionamiento()
                })
            }
        },
        direccionamiento(){
            if (this.respuesta=='success') {
                this.$router.push('/')
            } else {
                swal({
                    title:'No se pudo registrar',
                    icon: 'error'})  
            }
        },
  },
  created(){
    this.ajax()
    this.usuario()
  },
  components:{
    Cabecera,
    Menu
  },
  mixins:[sesion,eliminar]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/Trazabilidad.vue